export function equal (obj1, obj2) {
  return JSON.stringify(obj1, Object.keys(obj1).sort())
    === JSON.stringify(obj2, Object.keys(obj2).sort())
}